<template>
  <div :class="classObject" v-resize>
    <navbar class="d-print-none" v-show="initialized"></navbar>
    <sidebar class="d-print-none" v-show="initialized"></sidebar>

    <div class="content-wrap" id="content-wrap">
      <main id="content" class="content" role="main">
        <vuestic-breadcrumbs v-show="initialized" :breadcrumbs="breadcrumbs" class="d-print-none"/>
        <vuestic-pre-loader v-if="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
        <router-view v-if="!isLoading"></router-view>
      </main>
    </div>

    <div class="made-by-footer d-print-none" v-show="initialized">
      <!--©2018. Made by&nbsp;<a href="http://epicmax.co" target="_blank">Epicmax</a>-->
      ©2018. Made by&nbsp;<a href="http://fletrix.com.hk" target="_blank">Fletrix</a>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import Navbar from './navbar/Navbar';
  import Sidebar from './sidebar/Sidebar';
  import Resize from 'directives/ResizeHandler';

  export default {
    name: 'layout',

    components: {
      Navbar,
      Sidebar,
    },
    directives: {
      resize: Resize,
    },
    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation',
        'isLoading',
        'initialized',
      ]),
      classObject: function () {
        return {
          'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
          'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened,
        };
      },
      breadcrumbs () {
        return this.$store.getters.breadcrumbs(this.$route.name);
      },
    },
  };
</script>

<style lang="scss">
  @import "../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .content-wrap {
    margin-left : $content-wrap-ml;
    padding     : $content-wrap-pt $content-wrap-pr $content-wrap-pb 0;
    transition  : margin-left 0.3s ease;

    .pre-loader {
      position : absolute;
      left     : $vuestic-preloader-left;
      top      : $vuestic-preloader-top;
    }

    .sidebar-hidden & {
      margin-left : $sidebar-left;
    }

    @include media-breakpoint-down(md) {
      padding     : $content-mobile-wrap;
      margin-left : 0;

      .sidebar-hidden & {
        margin-left : 0;
      }
    }

    @media print {
      margin     : 0 !important;
      padding    : 0 !important;
      overflow-x : hidden;
    }
  }

  .made-by-footer {
    position        : absolute;
    bottom          : 0;
    height          : calc(#{$layout-padding} + #{$widget-mb});
    width           : 100%;
    display         : flex;
    justify-content : center;
    align-items     : center;

    @media print {
      display : none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Layout.vue